// extracted by mini-css-extract-plugin
export default {"delete_button":"index_delete_button__tRuo8"};